export const environment = {
    production: true,
    apiHost: "https://uat.samadhan.upnn.co.in",
    // apiHost: "http://192.168.29.9",
    apiPort: 3008,
    loginWithPassword: true
  };
  